export const CRYPTO_SYMBOLS = {
  BTC: '₿',
  ETH: 'Ξ',
  USDT: '₮',
  USDC: '$',
  SOL: '◎',
  TON: '💎',
  AED: 'د.إ'
};

export const CRYPTO_NAMES = {
  BTC: 'Bitcoin',
  ETH: 'Ethereum',
  USDT: 'Tether',
  USDC: 'USD Coin',
  SOL: 'Solana',
  TON: 'Toncoin',
  AED: 'UAE Dirham'
};

export const NETWORKS = {
  BTC: ['Bitcoin'],
  ETH: ['Ethereum'],
  USDT: ['TRON (TRC20)'],
  USDC: ['Base Network'],
  SOL: ['Solana'],
  TON: ['TON Network']
};

export const formatCurrency = (amount, currency = 'AED') => {
  if (currency === 'AED') {
    return `${CRYPTO_SYMBOLS[currency]} ${amount.toLocaleString('en-AE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  return `${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 8 })} ${currency}`;
};

// Format based on display preference
export const formatBalanceDisplay = (balance, cryptoBalance, displayMode = 'AED') => {
  if (displayMode === 'CRYPTO') {
    return `${cryptoBalance.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 8 })}`;
  }
  return formatCurrency(balance);
};

// Get display currency suffix
export const getDisplaySuffix = (crypto, displayMode = 'AED') => {
  if (displayMode === 'CRYPTO') {
    return crypto;
  }
  return 'AED';
};

// Get currency display from localStorage
export const getCurrencyDisplay = () => {
  return localStorage.getItem('currency_display') || 'USDT';
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-AE', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
};
